<template>
  <div class="marquee" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
    <el-row>
      <el-col :xs="{ offset: 1, span: 22 }" :sm="{ offset: 2, span: 9 }" :md="{ offset: 3, span: 8 }"
        class="site-intro">
        <h1 class="light headline"><span v-html="headline"></span></h1>
        <span class="subhead" v-html="subhead"></span>
      </el-col>
      <el-col :xs="{ offset: 1, span: 22 }" :sm="{ offset: 2, span: 9 }" :md="{ offset: 2, span: 8 }"
        class="site-features">
        <div class="products hide-xs">
          <el-row>
            <el-col :span="22">
              <h3 class="light">{{ productsHeadline }}</h3>
            </el-col>
            <el-col :span="2">
              <img src="@/assets/images/home/products-icon.svg" />
            </el-col>
          </el-row>
          <div class="light" v-html="productsText"></div>
          <router-link :to="{ name: 'Products' }" class="arrow light">{{ productsLinkText }}</router-link>
        </div>
        <hr v-if="isTrainingEnabled" class="hide-xs" />
        <div v-if="isTrainingEnabled" class="hide-xs training">
          <el-row>
            <el-col :span="22">
              <h3 class="light">{{ trainingHeadline }}</h3>
            </el-col>
            <el-col :span="2">
              <img src="@/assets/images/home/training-icon.svg" />
            </el-col>
          </el-row>
          <div class="light" v-html="trainingText"></div>
          <router-link :to="{ name: 'Training' }" class="arrow light">{{ trainingLinkText }}</router-link>
        </div>

        <div class="show-xs mobile-link-wrap">
          <router-link :to="{ name: 'Products' }" class="mobile-link arrow light">
            {{ productsLinkText }}
          </router-link>
        </div>

        <div class="show-xs mobile-link-wrap">
          <router-link :to="{ name: 'Training' }" class="mobile-link arrow light">
            {{ trainingLinkText }}
          </router-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import home from './';
import user from '../user';

export default {
  name: 'HomeMarquee',
  computed: {
    ...mapState(home.store.namespace, [
      'homeMarquee'
    ]),
    ...mapGetters(user.store.namespace, [
      'isTrainingEnabled'
    ]),
    headline() {
      const val = this.homeMarquee?.marqueeHeadline || '';
      return val.replace('\n', '<br />');
    },
    subhead() {
      return this.homeMarquee?.marqueeSubhead || '';
    },
    backgroundImage() {
      return this.homeMarquee?.mainImage?.[0]?.url || '';
    },
    productsHeadline() {
      return this.homeMarquee?.marqueeProductsHeadline || '';
    },
    productsText() {
      return this.homeMarquee?.marqueeProductsText || '';
    },
    productsLinkText() {
      return this.homeMarquee?.marqueeProductsLinkText || '';
    },
    trainingHeadline() {
      return this.homeMarquee?.marqueeTrainingHeadline || '';
    },
    trainingText() {
      return this.homeMarquee?.marqueeTrainingText || '';
    },
    trainingLinkText() {
      return this.homeMarquee?.marqueeTrainingLinkText || '';
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';

.marquee {
  margin-bottom: -12rem;
  padding: 8rem 0 20rem 0;

  @include res(xs) {
    padding: 2rem 0;
    margin-bottom: 0;
  }

  @include res(sm) {
    padding: 4rem 0 16rem 0;
  }

  background-size: cover;
  background-repeat: no-repeat;
  background-color: #04090c;
}

.site-intro {
  @include res(xs) {
    margin-bottom: 2rem;
  }
}

.site-features {
  background-color: #003A50;
  padding: 2rem;

  @include res(xs) {
    background-color: transparent;
    padding: 0px;
  }
}

.hide-xs {
  display: block;

  @include res(xs) {
    display: none;
  }
}

.show-xs {
  display: none;

  @include res(xs) {
    display: block;
  }
}

.mobile-link {
  display: block;
  width: 100%;
  text-align: center;
  /* same as color-primary; element override not working */
  background-color: #e50b19;
  padding: 20px 0px;
}

.mobile-link-wrap {
  margin-bottom: 12px;
}

:deep(.subhead) {
  color: $--color-white;

  p {
    color: $--color-white;
  }
}
</style>
